import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initPostHog } from "./lib/posthog";

// Defer PostHog initialization to after first paint to improve FCP
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => initPostHog());
} else {
  setTimeout(() => initPostHog(), 1);
}

createRoot(document.getElementById("root")!).render(<App />);
